import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import {Tooltip} from "antd";
import {
    BarChartRounded,
    PieChartRounded,
    StackedLineChartRounded,
    TableRowsSharp,
    AutoGraphRounded
} from "@mui/icons-material";
import React from "react";


const ChartTypeMenu = ({chartType, setChartType}) => {
  return (
              <ButtonGroup
                  size={'small'}
                  color={'inherit'}
                  exclusive
                  variant={'outlined'}
              >
                      <Button variant={chartType==='indices'?'contained':''}
                              onClick={()=>setChartType('indices')}
                              startIcon={<AutoGraphRounded/>}
                      >
                          Portfolio + Style Indices
                      </Button>
                      <Button variant={chartType==='pie'?'contained':''}
                              onClick={()=>setChartType('pie')}
                              startIcon={<PieChartRounded/>}
                              value={'pie'}
                      >
                          Monthly Snapshots
                      </Button>
                      <Button variant={chartType==='table'?'contained':''}
                              onClick={()=>setChartType('table')}
                              startIcon={<TableRowsSharp/>}
                                value={'table'}
                      >
                          Allocation Tables
                      </Button>
                      <Button variant={chartType==='bar'?'contained':''}
                              onClick={()=>setChartType('bar')}
                              startIcon={<BarChartRounded/>}
                                value={'bar'}
                      >
                          Bar Chart (Classic)
                      </Button>
              </ButtonGroup>
  );
};
export default ChartTypeMenu;